import { getSnowplowEventPayload, logAnalyticsEvent } from 'Services/analytics/analytics';
import { ANALYTICS_CATEGORIES, SNOWPLOW_EVENTS } from 'Services/analytics/analytics.const';

const { ACCOUNT } = ANALYTICS_CATEGORIES;
const { CLICK } = SNOWPLOW_EVENTS;

interface TriggerSellerMessagingBackButtonClickedEventParams {
	from: 'Create email' | 'Mark as contacted confirmation';
	to: 'Seller contact selection';
}

export const triggerSellerMessagingBackButtonClickedEvent = ({
	from,
	to,
}: TriggerSellerMessagingBackButtonClickedEventParams): void => {
	const label = { from, to };
	const eventPayload = getSnowplowEventPayload({
		category: ACCOUNT.SELLER_MESSAGING,
		customData: { label: JSON.stringify(label) },
		name: 'dlr_seller_messaging_back_button_clicked',
		schemaName: CLICK.SCHEMA,
		version: CLICK.VERSION,
	});

	logAnalyticsEvent({ eventPayload });
};
